@if (label && label.length > 0) {
  <label class="form-label">
    {{ label }}
  </label>
}
<ng-select
  #ngSelect
  [items]="options"
  [searchable]="searchable"
  [(ngModel)]="selected"
  [ngClass]="{ 'ng-select-error': !!error, 'ng-select-placeholder': addEmptyState() }"
  [appendTo]="appendTo"
  [dropdownPosition]="dropdownPosition"
  [clearable]="clearable"
  [virtualScroll]="true"
  [disabled]="disabled"
  [notFoundText]="'no_items_found' | translate"
  [bindLabel]="bindLabel"
  (search)="enableClearFunction($event)"
  (open)="onOpen()"
  (clear)="onClear()"
  [placeholder]="placeholder | translate"
  (scrollToEnd)="onScrollToEnd()"
  [clearOnBackspace]="false"
  (close)="closeDropdown(searchTermOnClose)"
  [loading]="isLoading"
  [searchFn]="customSearchFn">
  <ng-template ng-option-tmp ng-label-tmp let-item="item">
    <div class="card-body">
      <span class="card-title font-size-15">
        @if (!!item.iconUrl) {
          <span
            ><img
            [src]="item.iconUrl"
            class="icon-url"
            (error)="img.src = '/assets/images/default-asset.svg'"
            #img
          /></span>
        }
        @if (!!item.icon) {
          <span
            class="{{ item.icon }} card-title__item card-title__item__icon"
					[ngClass]="{
						'bpi__asset-crypto font-size-32': !isCountrySelection(),
						'font-size-17': isCountrySelection()
					}"></span>
        }
        <span class="card-title__item card-title__item__name">
          <span>{{ item.name | translate }}</span>
        </span>
        @if(showDetails) {
          <span class="card-title__item card-title__item__amount">{{ item.details }}</span>
        }
      </span>
    </div>
  </ng-template>
</ng-select>
@if (bottomLabel) {
  <div class="bottom-label-layout">
    <a class="bottom-label" [href]="bottomLabelHyperlink" [target]="'_blank'">
      {{ bottomLabel }}
    </a>
    <div class="bottom-label bpi__icon-info ml-5"></div>
  </div>
}
@if (!!error) {
  <span class="form-error">
    {{ error }}
  </span>
}
